var _defs, _g, _g2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "svg2",
    viewBox: "0 0 768 768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPathFlag",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect3918",
    fillOpacity: 0.67,
    ry: 57,
    height: 511,
    width: 511,
    y: 0.5,
    x: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3852-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop3854-6",
    stopColor: "#dbe3db",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop3856-1",
    stopColor: "#dbe3db",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5122",
    x1: 342.19,
    xlinkHref: "#linearGradient3852-0",
    gradientUnits: "userSpaceOnUse",
    y1: 705.76,
    gradientTransform: "matrix(1.1571 0 0 1.3167 -91.204 -253.99)",
    x2: 358.08,
    y2: 523.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5125",
    x1: 405.26,
    xlinkHref: "#linearGradient3852-0",
    gradientUnits: "userSpaceOnUse",
    y1: 118.06,
    gradientTransform: "matrix(.95303 0 0 .86647 11.575 -4.5016)",
    x2: 405.75,
    y2: 360.92
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter5740"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur5742",
    stdDeviation: 5.12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5796",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect5798",
    ry: 57,
    height: 512,
    width: 512,
    stroke: "#00fa00",
    y: 0,
    x: 0,
    strokeWidth: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5912"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur5914",
    stdDeviation: 17.92
  })))), /*#__PURE__*/React.createElement("g", {
    id: "template-button"
  }, "&gt;\n        ", _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 0,
    transform: "translate(90,90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "shadow",
    ry: 57,
    height: 512,
    filter: "url(#filter5912)",
    width: 512,
    stroke: "#a8a8a8",
    y: 56,
    x: 38,
    strokeWidth: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(128,128)",
    clipPath: "url(#clipPathFlag)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mask",
    ry: 57,
    height: 512,
    width: 512,
    y: 0,
    x: 0,
    fill: "#00f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "flag",
    transform: "matrix(.48166 0 0 .72249 0 .0000024116)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect171",
    fillRule: "evenodd",
    height: 708.66,
    width: 1063,
    y: 0,
    x: 0,
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect403",
    fillRule: "evenodd",
    height: 708.66,
    width: 354.33,
    y: 0,
    x: 0,
    strokeWidth: "1pt",
    fill: "#005700"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect135",
    fillRule: "evenodd",
    height: 708.66,
    width: 354.33,
    y: 0,
    x: 708.66,
    strokeWidth: "1pt",
    fill: "#fc0000"
  })))), /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(0,38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3862-8",
    style: {
      color: "#000000"
    },
    fill: "url(#linearGradient5125)",
    d: "m214.21 111.21c-45.245 0.18809-68.716 7.7308-64.094 83.553l2.8252 46.345c47.474 5.5124 56.664 18.445 104.36 21.914 68.073 4.9513 67.937 5.4209 130.56-14.384 62.628-19.805 5.8248-65.247 207.32-57.82 4.6033 0.16968 17.314-3.0527 27.462-12.15 5.5817-46.524-2.7842-69.143-66.934-68.876z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3079-9",
    style: {
      color: "#000000"
    },
    fill: "url(#linearGradient5122)",
    d: "m531.03 495.17c-31.605 19.022-27.601 31.26-37.913 32.573-94.704 12.053-145.98-0.72701-165.8-12.061-59.588-34.078-68.468-13.014-100.22-16.574-20.115-2.2551-59.245 12.984-73.388 44.344 3.4722 27.608 18.111 32.098 44.281 31.986l356.06-1.5268c69.692-0.29885 56.335-8.4926 65.543-56.039-14.772-21.671-13.157 9.109-44.224-30.717z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect5734",
    transform: "translate(128,90)",
    clipPath: "url(#clipPath5796)",
    ry: 57,
    height: 512,
    filter: "url(#filter5740)",
    width: 512,
    stroke: "#000",
    y: 0,
    x: 0,
    strokeWidth: 20,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaly);
export default __webpack_public_path__ + "static/media/italy.58bf6a6041edbee7cf338a422d1c4158.svg";
export { ForwardRef as ReactComponent };